import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import type { AccountDetailPayload } from './account-detail.model';
import type { AccountPathType } from './account-path-type';
import type {
  AccountTransactionsPayload,
  GetAccountTransactionsOptions,
} from './account-transactions.model';
import type { GetAccountsPayload } from './accounts.model';

/**
 * Seam for AIM GET /account, GET /account/{type}/{id},
 * and GET /account/{type}/{id}/transactions (Checking / Savings / Debt).
 * Store + UI depend only on this token. Production uses `provideAccounts()`;
 * tests may opt into the internal `provideMockAccounts()` helper.
 */
export interface AccountsApi {
  getAccounts(guid: string): Observable<GetAccountsPayload>;
  getAccount(
    guid: string,
    pathType: AccountPathType,
    id: string
  ): Observable<AccountDetailPayload>;
  getAccountTransactions(
    guid: string,
    pathType: AccountPathType,
    id: string,
    options?: GetAccountTransactionsOptions
  ): Observable<AccountTransactionsPayload>;
}

export const ACCOUNTS_API = new InjectionToken<AccountsApi>('ACCOUNTS_API');
